import { Provider } from '@angular/core';
import { Store } from '@ngrx/store';

import { RoleService } from '@ninety/platform/services/services/role.service';
import { extractValueFromStore } from '@ninety/platform/services/state-util';
import { selectCurrentUser } from '@ninety/platform/state/app-entities/users/users-state.selectors';
import { USER_CAN_EDIT_TITLE, UserCanEditTitleProvider } from '@ninety/ui/core';

/**
 * Binds the `USER_CAN_EDIT_TITLE` token consumed by `InlineEditableTitleComponent` in `@ninety/ui/core`
 * to the real role check (`RoleService.minRole.lite` against the current user from `platform/state`).
 * The component stays free of any `@ninety/platform/state` and `@ninety/platform/services` dependency so
 * it can be packaged in the public API; this composition-root wiring is the single place that depends on
 * both the token and those platform libs. (DEV-26530 Part 7)
 */
export const INLINE_EDITABLE_TITLE_PROVIDERS: Provider[] = [
  {
    provide: USER_CAN_EDIT_TITLE,
    useFactory:
      (store: Store): UserCanEditTitleProvider =>
      () =>
        RoleService.minRole.lite(extractValueFromStore(store, selectCurrentUser)?.roleCode),
    deps: [Store],
  },
];
